import { render, staticRenderFns } from "./WriteTestimonial.vue?vue&type=template&id=208ffc76"
import script from "./WriteTestimonial.vue?vue&type=script&lang=js"
export * from "./WriteTestimonial.vue?vue&type=script&lang=js"
import style0 from "./WriteTestimonial.vue?vue&type=style&index=0&id=208ffc76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports